import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Note } from '../case/model/note';
import { NotesService } from '../core/service/notes.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { AuthenticationService } from '../core/authentication/authentication.service';

@Component({
  standalone: false,
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent
{
  @Input() public notesDialogOpened: boolean;
  @Input() public note: Note;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public removed = new EventEmitter<number>();
  @Output() public added = new EventEmitter<any>();

  public deleteConfirmationOpened = false;
  public editMode = false;
  public maxNoteLength = 4000;
  public isNewNote = false;

  constructor(
    private notesService: NotesService,
    private authenticationService: AuthenticationService,   // Do not remove: used in html
    private messageHandlerService: MessageHandlerService) { }

  @Input() public set isNew(value: boolean)
  {
    this.editMode = value;
    this.isNewNote = value;
  }

  /**
   * Save a note.
   */
  public save(): void
  {
    this.notesService.saveNote(this.note, this.isNewNote).subscribe({
      next: (data) =>
      {
        this.note.id = data.id;
        this.notesDialogOpened = false;
        this.editMode = false;
        this.messageHandlerService.displaySuccess('NOTE-SAVED-SUCCESSFULLY');
        this.added.emit();
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }

  /**
   * Cancel the note edit modal. If note is not persisted, the note will be deleted from the note list.
   */
  public cancelNote(): void
  {
    this.notesDialogOpened = false;
    this.editMode = false;
    this.cancelling.emit();
  }

  /**
   * Soft deleting a note. Server is being called only if the note have been persisted already.
   */
  public deleteNote(): void
  {
    this.notesService.deleteNote(this.note.id).subscribe({
      next: () =>
      {
        this.messageHandlerService.displaySuccess('NOTE-DELETED-SUCCESSFULLY');
        this.removed.emit(this.note.id);
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }

  /**
   * Button action handler.
   *
   * @param confirmed The action have been confirmed: true/false.
   */
  public deleteAction(confirmed: boolean): void
  {
    this.deleteConfirmationOpened = false;
    if (confirmed)
    {
      this.deleteNote();
      this.notesDialogOpened = false;
      this.editMode = false;
    }
  }
}
